import { Link } from 'react-router-dom';

// Social icons as SVG paths
const SOCIALS = [
  {
    name: 'X / Twitter',
    href: 'https://twitter.com/millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://linkedin.com/company/millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    name: 'Facebook',
    href: 'https://facebook.com/millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://instagram.com/millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
      </svg>
    ),
  },
  {
    name: 'TikTok',
    href: 'https://tiktok.com/@millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
      </svg>
    ),
  },
  {
    name: 'YouTube',
    href: 'https://youtube.com/@millehills',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    name: 'WhatsApp',
    href: 'https://wa.me/250782603593',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
      </svg>
    ),
  },
];

const COLS = [
  {
    title: 'Services',
    links: [
      { to: '/services?cat=web',   label: 'Web & Digital'      },
      { to: '/services?cat=ux',    label: 'Design & UX'        },
      { to: '/services?cat=media', label: 'Media Production'   },
      { to: '/services?cat=ict',   label: 'ICT Infrastructure' },
    ],
  },
  {
    title: 'Learn & Grow',
    links: [
      { to: '/academy',                    label: 'All Programs'       },
      { to: '/academy?type=bootcamp',      label: 'Bootcamps'          },
      { to: '/academy?tab=internships',    label: 'Internships'        },
      { to: '/academy?type=certification', label: 'Certifications'     },
      { to: '/verify',                      label: 'Verify Certificate' },
    ],
  },
  {
    title: 'Ecosystem',
    links: [
      { to: '/about',        label: 'About MilleHills' },
      { to: '/about#mara',   label: 'MARA Matsiko'     },
      { to: '/about#baybees',label: 'BayBees 2.1'      },
      { to: '/news',         label: 'News & Insights'  },
    ],
  },
  {
    title: 'Connect',
    links: [
      { to: '/contact',                label: 'Contact Us'     },
      { to: '/contact?type=partner',   label: 'Partner With Us'},
      { to: '/contact?type=volunteer', label: 'Volunteer'      },
      { to: '/dashboard',              label: 'My Account'     },
    ],
  },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--bg-1)', borderTop: '1px solid var(--border)', paddingTop: 'clamp(60px,8vw,100px)' }}>
      <div className="container">

        {/* Top section */}
        <div style={{ display: 'grid', gridTemplateColumns: '280px repeat(4, 1fr)', gap: 40, paddingBottom: 60, borderBottom: '1px solid var(--border)' }}>

          {/* Brand */}
          <div>
            {/* Logo */}
            <div style={{ marginBottom: 18 }}>
              <picture>
                <source srcSet="/logos/logo-light.png" media="(prefers-color-scheme: light)" />
                <img src="/logos/logo-dark.png" alt="MilleHills"
                  style={{ height: 40, width: 'auto', objectFit: 'contain' }}
                  onError={e => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              </picture>
              {/* Fallback */}
              <div style={{ display: 'none', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 36, height: 36, background: 'var(--gold)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 20, color: '#080a0d' }}>M</div>
                <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 700 }}>MilleHills</span>
              </div>
            </div>

            <p style={{ fontSize: '0.875rem', color: 'var(--t-secondary)', lineHeight: 1.7, marginBottom: 20 }}>
              A technology and innovation ecosystem building Africa's future from Gisenyi, Rwanda.
            </p>

            <div style={{ fontSize: '0.75rem', color: 'var(--t-muted)', lineHeight: 2, marginBottom: 24 }}>
              <div>Gisenyi, Rubavu District</div>
              <div>Western Province, Rwanda</div>
              <a href="mailto:hello@millehills.com" style={{ color: 'var(--gold)', textDecoration: 'none', display: 'block', marginTop: 6 }}>hello@millehills.com</a>
              <a href="tel:+250782603593" style={{ color: 'var(--t-muted)', textDecoration: 'none' }}>+250 782 603 593</a>
            </div>

            {/* Social icons */}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {SOCIALS.map(s => (
                <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer"
                  title={s.name}
                  style={{ width: 34, height: 34, borderRadius: 8, background: 'var(--bg-2)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--t-muted)', transition: 'all 0.15s', textDecoration: 'none' }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(232,164,58,0.1)'; e.currentTarget.style.borderColor = 'rgba(232,164,58,0.35)'; e.currentTarget.style.color = 'var(--gold)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'var(--bg-2)'; e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--t-muted)'; }}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {COLS.map(col => (
            <div key={col.title}>
              <div className="label" style={{ color: 'var(--t-muted)', marginBottom: 16 }}>{col.title}</div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
                {col.links.map(l => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} style={{ fontSize: '0.875rem', color: 'var(--t-secondary)', transition: 'color 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.color = 'var(--t-primary)'}
                      onMouseLeave={e => e.currentTarget.style.color = 'var(--t-secondary)'}
                    >{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Brands strip */}
        <div style={{ display: 'flex', gap: 24, padding: '20px 0', borderBottom: '1px solid var(--border)', flexWrap: 'wrap' }}>
          {[
            { name: 'MilleHills Core', tag: 'Parent Entity',   color: 'var(--gold)',  icon: 'M' },
            { name: 'MARA Matsiko',    tag: 'Media Sub-Brand', color: '#2dd4bf',      icon: 'M' },
            { name: 'BayBees 2.1',     tag: 'Kids & Youth',    color: '#f472b6',      icon: 'B' },
          ].map(b => (
            <div key={b.name} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 28, height: 28, borderRadius: 6, background: `${b.color}18`, border: `1px solid ${b.color}33`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: b.color, fontFamily: 'var(--font-display)' }}>{b.icon}</div>
              <div>
                <div style={{ fontSize: '0.78rem', fontWeight: 600, color: 'var(--t-secondary)' }}>{b.name}</div>
                <div style={{ fontSize: '0.65rem', color: 'var(--t-muted)' }}>{b.tag}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 0', fontSize: '0.75rem', color: 'var(--t-muted)', flexWrap: 'wrap', gap: 10 }}>
          <span>© {new Date().getFullYear()} MilleHills Ltd. All rights reserved.</span>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <Link to="/verify" style={{ color: 'var(--t-muted)', textDecoration: 'none', transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--gold)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--t-muted)'}
            >Verify Certificate</Link>
            <span style={{ color: 'var(--border)' }}>·</span>
            <span style={{ color: 'var(--border)' }}>Founder-Led · Constitution-Protected · Capital-Flexible</span>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          footer .container > div:first-child {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 600px) {
          footer .container > div:first-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
}
